export default "__VITE_ASSET__CuRzGJTl__"